import { crmTenant } from './crm';
import { fullTenant } from './full';
import type { Tenant, TenantConfig } from './types';

import { tenants } from '.';

const tenantByVariant: Record<Tenant, TenantConfig> = {
  full: fullTenant,
  crm: crmTenant,
};

export const resolveTenant = (): TenantConfig => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    const labels = hostname.split('.');
    const isCrmTenant = labels.includes(tenants.crm);

    if (isCrmTenant) {
      return tenantByVariant[tenants.crm];
    }
  }

  return fullTenant;
};
